/*global _ */
import {name, mixins, props, data} from './config'
import {getProductById} from '../../../../../lib/store/product'

export default {
  name,
  mixins,
  props,
  data() {
    return {
      ...data,
    }
  },
  computed: {
    products() {
      return _.reduce(this.innerValue, (result, quantity, id) => {
        const product = getProductById(id)
        if (product) {
          result[id] = product
        }
        return result
      }, {})
    }
  },
  methods: {
    getProductDetails(product) {
      const details = []
      const cashes = product.balance || {}
      const credits = cashes.cash || 0
      const bonus_credits = cashes.bonus_cash || 0
      if (credits) {
        details.push(`${credits} Credits`)
      }
      if (bonus_credits) {
        details.push((credits ? '+' : '') + `${bonus_credits} Bonus credits`)
      }
      return details
    }
  }
}
